import type { GrantDetailDto } from '@zoxo/shared';

/**
 * 브리프 — **이 화면에서 유일하게 우리가 쓴 글**.
 *
 * 나머지는 전부 원문에서 뽑아 대조를 통과한 값이다. 같은 판에 같은 무게로
 * 놓이면 독자는 어디까지가 기관이 말한 것이고 어디부터가 우리 판단인지 모른다.
 * 그래서 인용 블록으로 떼어 놓는다.
 *
 * 지원 내용 표보다 **위**에 둔다 — 검색으로 들어온 사람이 처음 읽는 것이
 * 이 문단이어야 한다.
 *
 * 없을 수 있다. 원문이 얇거나 모델이 쓸 말이 없다고 판단하면 안 쓴다
 * (docs/superpowers/specs/2026-09-28-grant-brief-design.md §3).
 */
export function GrantBrief({ grant }: { grant: GrantDetailDto }) {
  if (!grant.brief) return null;
  return (
    <blockquote className="mt-6 border-l-4 border-primary/40 bg-primary/5 py-4 pl-5 pr-4">
      <p className="whitespace-pre-line text-[15px] leading-relaxed text-gray-800">{grant.brief}</p>
    </blockquote>
  );
}
